<template>
    <div class="customer">
        <div class="shop_user_box">
            <p>
                <span>店铺用户</span>
                <!-- <el-tooltip placement="top">
                    <div class="tooltip_content" slot="content">筛选时间内，店铺内访客数最高5个商品（商品仅包括需要付费的单品、专栏、大专栏、会员、训练营、社群、活动）。 转化率：付费用户数/访客数</div>
                    <img class="tooltip_icon" :src="icon1" alt="">
                </el-tooltip> -->
            </p>
            <div class="data_box">
                <div>
                    <p>
                        <span>累计用户</span>
                        <el-tooltip placement="top">
                            <div class="tooltip_content" slot="content">累计用户：截至到筛选时间，访问过店铺的全部用户数。</div>
                            <img class="tooltip_icon" :src="icon1" alt="">
                        </el-tooltip>
                    </p>
                    <p>{{shopUserData[1].cumulativeUsers}}</p>
                    <p>日环比 {{shopUserData[1].cumulativeUsersdaythan}}</p>
                    <p>周同比 {{shopUserData[1].cumulativeUsersweekthan}}</p>
                </div>
                <div>
                    <p>
                        <span>新增用户</span>
                        <el-tooltip placement="top">
                            <div class="tooltip_content" slot="content">新增用户：筛选时间内，第一次访问店铺的用户数</div>
                            <img class="tooltip_icon" :src="icon1" alt="">
                        </el-tooltip>
                    </p>
                    <p>{{shopUserData[2].newUsers}}</p>
                    <p>日环比 {{shopUserData[2].newUsersdaythan}}</p>
                    <p>周同比 {{shopUserData[2].newUsersweekthan}}</p>
                </div>
                <div>
                    <p>
                        <span>活跃用户</span>
                        <el-tooltip placement="top">
                            <div class="tooltip_content" slot="content">活跃用户：筛选时间内，访问过店铺的用户数</div>
                            <img class="tooltip_icon" :src="icon1" alt="">
                        </el-tooltip>
                    </p>
                    <p>{{shopUserData[3].activeUsers}}</p>
                    <p>日环比 {{shopUserData[3].activeUsersdaythan}}</p>
                    <p>周同比 {{shopUserData[3].activeUsersweekthan}}</p>
                </div>
            </div>
            <div class="echarts_line_box">
                <Echarts4 :shopUserDatas="shopUserDatas"></Echarts4>
            </div>
            <!-- <p>
                <span>店铺付费新老用户</span>
                <el-tooltip placement="top">
                    <div class="tooltip_content" slot="content">新付费用户数：筛选时间之前没有在店铺付过费，在筛选时间内在店铺首次付款的用户数量<br />老付费用户：筛选时间内，在店铺内有付款，且首次付款是在筛选时间之前的用户数(拼团在成团时计入筛选，问答在回答后计入筛选，API导入订单不计入筛选)</div>
                    <img class="tooltip_icon" :src="icon1" alt="">
                </el-tooltip>
            </p>
            <div class="echarts_bar_box">
                <div>
                    <div>
                        <Echarts6></Echarts6>
                    </div>
                </div>
                <div>
                    <div>
                        <Echarts6></Echarts6>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="shop_pay_user_box">
            <p>
                <span>店铺付费用户</span>
                <!-- <el-tooltip placement="top">
                    <div class="tooltip_content" slot="content">筛选时间内，店铺内访客数最高5个商品（商品仅包括需要付费的单品、专栏、大专栏、会员、训练营、社群、活动）。 转化率：付费用户数/访客数</div>
                    <img class="tooltip_icon" :src="icon1" alt="">
                </el-tooltip> -->
            </p>
            <div class="data_box">
                <div>
                    <p>
                        <span>累计付费用户</span>
                        <el-tooltip placement="top">
                            <div class="tooltip_content" slot="content">累计付费用户：截至到筛选时间，店铺内所有付款成功的用户数（拼团在成团时计入筛选，问答在回答后计入筛选，API导入订单不计入筛选）</div>
                            <img class="tooltip_icon" :src="icon1" alt="">
                        </el-tooltip>
                    </p>
                    <p>{{shopPayingUserData[1].cumulativepayusers}}</p>
                    <p>日环比 {{shopPayingUserData[1].cumulativepayusersdaythann}}</p>
                    <p>周同比 {{shopPayingUserData[1].cumulativepayusersweekthan}}</p>
                </div>
                <div>
                    <p>
                        <span>付费用户</span>
                        <el-tooltip placement="top">
                            <div class="tooltip_content" slot="content">付费用户：筛选时间内，付款成功的用户数，一个人多次付款记为一个（拼团在成团时计入筛选，问答在回答后计入筛选，API导入订单不计入筛选</div>
                            <img class="tooltip_icon" :src="icon1" alt="">
                        </el-tooltip>
                    </p>
                    <p>{{shopPayingUserData[2].orderpaycustomer}}</p>
                    <p>日环比 {{shopPayingUserData[2].orderpaycustomerdaythan}}</p>
                    <p>周同比 {{shopPayingUserData[2].orderpaycustomerweekthan}}</p>
                </div>
                <div>
                    <p>
                        <span>活跃付费用户</span>
                        <el-tooltip placement="top">
                            <div class="tooltip_content" slot="content">活跃付费用户：筛选时间内，访问过店铺的付费用户数（拼团在成团时计入筛选，问答在回答后计入筛选，API导入订单不计入筛选）</div>
                            <img class="tooltip_icon" :src="icon1" alt="">
                        </el-tooltip>
                    </p>
                    <p>{{shopPayingUserData[3].activePayingUser}}</p>
                    <p>日环比 {{shopPayingUserData[3].activepayinguserdaythan}}</p>
                    <p>周同比 {{shopPayingUserData[3].activePayingUserweekthan}}</p>
                </div>
            </div>
            <div class="echarts_line_box">
                <Echarts5 :shopPayingUserDatas="shopPayingUserDatas"></Echarts5>
            </div>
            <!-- <p>
                <span>客户复购率</span>
                <el-tooltip placement="top">
                    <div class="tooltip_content" slot="content">周复购率：筛选日期所在周，本周前在店铺有过付费且本周有付费的用户数 / 本周总付费用户数<br />月复购率：筛选日期所在月，本月前在店铺有过付费且本月有付费的用户数 / 本月总付费用户数</div>
                    <img class="tooltip_icon" :src="icon1" alt="">
                </el-tooltip>
            </p>
            <div class="rep_rate_box">
                <div>
                    <div>
                        <p>本周</p>
                        <p>- -</p>
                        <p>较上一周 - -</p>
                    </div>
                    <div>
                        <p>本月</p>
                        <p>- -</p>
                        <p>较上一月 - -</p>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import Echarts4 from 'views/dataCenter/dataTabs/echarts/Echarts4'
import Echarts5 from 'views/dataCenter/dataTabs/echarts/Echarts5'
// import Echarts6 from 'views/dataCenter/dataTabs/echarts/Echarts6'
export default {
    name: 'customer',
    props: ['shopUserData', 'shopPayingUserData'],
    data() {
        return {
            icon1: require('@/common/images/other/data_center_tools_icon@2x.png'),
            shopUserDatas: [],
            shopPayingUserDatas: []
        }
    },
    mounted() {},
    methods: {},
    filters: {},
    watch: {
        shopUserData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.shopUserDatas = this.shopUserData
            })
        },
        shopPayingUserData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.shopPayingUserDatas = this.shopPayingUserData
            })
        }
    },
    computed: {},
    components: {
        Echarts4,
        Echarts5
        // Echarts6
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.customer {
    display: flex;
    &>div{
        width: 50%;
    }
    .shop_user_box, .shop_pay_user_box{
        padding-right: 30px;
        &>P {
            display: flex;
            align-items: center;
            height:20px;
            line-height:20px;
            color: #606266;
            margin-bottom: 15px;
            img{
                margin-left: 10px;
                width: 14px;
                height: 14px;
                cursor: pointer;
            }
        }
        .data_box{
            display: flex;
            margin-bottom: 20px;
            &>div{
                width: 33.3%;
                border: 1px solid #DCDFE6;
                border-right: none;
                height: 158px;
                padding: 20px;
                box-sizing: border-box;
                p{
                    height: 20px;
                    line-height: 20px;
                }
                p:nth-of-type(1){
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 2px;
                    img{
                        width: 14px;
                        height: 14px;
                        cursor: pointer;
                    }
                }
                p:nth-of-type(2){
                    height: 40px;
                    line-height: 40px;
                    font-size:28px;
                    font-weight:500;
                }
                p:nth-of-type(3){
                    margin: 6px 0 10px 0;
                }
            }
            &>div:nth-of-type(3) {
                border-right: 1px solid #DCDFE6;
            }
        }
        .echarts_line_box{
            height: 330px;
            margin-bottom: 20px;
        }
        .echarts_bar_box{
            display: flex;
            &>div{
                width: 50%;
                height: 360px;
                display: flex;
                justify-content: center;
                align-items: center;
                &>div{
                    width: 250px;
                    height: 320px;
                }
            }
        }
        .rep_rate_box{
            height: 310px;
            padding-top: 50px;
            color: #606266;
            &>div {
                display: flex;
                &>div {
                    margin-right: 90px;
                    p{
                        height: 30px;
                        line-height: 30px;
                        font-weight:600;
                    }
                    p:nth-of-type(3){
                        font-weight:400;
                    }
                }
                &>div:nth-of-type(2) {
                    margin-right: 0px;
                }
            }
        }
    }
    .shop_pay_user_box {
        padding-right: 0px;
        padding-left: 30px;
    }
}
</style>
<style scoped>
.tooltip_content {
    color: #606266;
    padding: 0 15px;
    line-height: 20px;
    width: 320px;
}
</style>